import { EventEmitter, Output, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalDataService } from '../../housekeeping/services/global-data.service';
import { FileUploadService } from '../../housekeeping/services/file-upload.service';
import { GlobalVariable } from '../../../../app/config';
import {HttpClient, HttpRequest, HttpEvent} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';


@Injectable()
export class OwnerService {
    public BASE_URL = GlobalVariable.FORDAPIEndPointURL;
  constructor(public _router: Router,public _globalDataService:GlobalDataService,public _fileUploadService:FileUploadService,private http: HttpClient) { }


  /**
   * @author Ciocan Vlad
   */
  checkVins(vins,callback){
    this._globalDataService.PostAjaxCall(this.BASE_URL + "/lms/owner/getForBulk",vins, (result) => {
      callback(result);
    })
  }
  /**
    * @author Ciocan Vlad
    * @uses view the owner detail page
    */
    viewOwnerDetails(vin, ownerId, userId,ownerVehicleId, callback) {
         this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/owner/details?userId="+userId+"&ownerId="+ownerId+"&vin="+vin+"&ownerVehicleId=" +ownerVehicleId, (result) => {
            callback(result);
        })
    }

    /**
     * @author Nagendra
     * @param offset,limit,userId
     */
    getOwnersList(userId,offset,limit,column,sort,callback){
        //console.log(this.BASE_URL+"/lms/owner/list?userId="+userId+"&offset="+offset+"&pageLimit="+limit+"&orderBy="+column+"&sortBy="+sort);
        this._globalDataService.GetAjaxCall(this.BASE_URL+"/lms/owner/list?userId="+userId+"&offset="+offset+"&pageLimit="+limit+"&orderBy="+column+"&sortBy="+sort, result =>{
            callback(result);
        })
    }

     /**
     * @author Nagendra
     * @description Get All owner preferences
     */

    getviewSettings(callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/owner/viewSettings/list", (result) => {
            callback(result);
        })
     }

    /**
     * @author Nagendra
     * @description Get Owner preferences
     */
    getOwnerPreference(userId,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/owner/userPreference/get?userId="+userId, (result) => {
            callback(result);
        })
    }

     /**
     * @author Nagendra
     * @description Save Owner preference
     */
    saveOwnerPreference(savePreference,callback){
        this._globalDataService.PostAjaxCall(this.BASE_URL + "/lms/owner/userPreference/save",savePreference, (result) => {
        callback(result);
        })
    }
    /**
     * @author Pradeep
     * @description get log Details for owner
     */
     getOwnerLogDetails(ownerId,callback){
         this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/owner/changeLog/list?ownerId="+ownerId, (result) => {
            callback(result);
        })
     }

    /**
    *@author Nagendra
    *@description For the different ownership cycle values
    */
//    getOwnershipCycle(callback) {
//         this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/owner/cycle/list", (result) => {
//            callback(result);
//        })
//    }

    /**
    *@author Nagendra
    *@description For the different sales type values
    */
    getOwnerSalesType(callback) {
         this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/owner/salesType/list", (result) => {
            callback(result);
        })
    }

    /**
    *@author Nagendra
    *@description For the Owner country list
    */
    getOwnerCountryList(callback) {
         this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/country/list", (result) => {
            callback(result);
        })
    }

    /**
    *@author Nagendra
    *@description For the Owner Dealer List
    */
    getOwnerDealerList(userId,callback) {
         this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/dealer/list?userId="+userId,(result) => {
            callback(result);
        })
    }

    getSearchOwnerList(searchObj,callback){
        this._globalDataService.PostAjaxCall(this.BASE_URL + "/lms/owner/searchWider", searchObj,(result) => {
            callback(result);
        })
    }

    /**
    *@author Nagendra
    *@description For owner basic search
    */
    getOwnerSearch(userid,searchText,offset,limit,column,sort,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/owner/search?userId="+userid+"&lastName="+searchText+"&offset="+offset+"&pageLimit="+limit+"&orderBy="+column+"&sortBy="+sort, (result) => {
        callback(result);
        })
    }



    /**
    * @author Nagendra
    * @description Get country List
    */
    getCountryListWithNamecode(callback) {
      const temp = [];
      this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/country/list", (result) => {
            result.forEach(obj => {
                temp.push({
                    id: obj.id,
                    name: obj.name,
                    code: obj.code,
                    namecode: obj.name + '(' + obj.code + ')'
                })
            });
            callback(temp)
        })
    }

    /**
    * @author Nagendra
    * @description Get Dealer List
    */
    getDealerListWithDesccode(userId,callback) {
      const temp = [];
      this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/dealer/list?userId="+userId,(result) => {
            result.forEach(obj => {
                temp.push({
                    id: obj.id,
                    name: obj.name,
                    globalCode: obj.globalCode,
                    desccode: obj.name + '(' + obj.globalCode + ')'
                })
            });
            callback(temp)
        })
    }

    /**
    * @author Nagendra
    * @description Get Sales Type
    */
    getSalesTypeWithDesccode(callback) {
      const temp = [];
      this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/owner/salesType/list", (result) => {
            result.forEach(obj => {
                temp.push({
                    id: obj.id,
                    description: obj.description,
                    code: obj.code,
                    desccode: obj.description + '(' + obj.code + ')'
                })
            });
            callback(temp)
        })
    }

    /**
    * @author Nagendra
    * @description Get Ownership cycle
    */
    getOwnershipCycleWithDesccode(callback) {
      const temp = [];
      this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/owner/cycle/list", (result) => {
            result.forEach(obj => {
                temp.push({
                    id: obj.id,
                    description: obj.description,
                    code: obj.code,
                    desccode: obj.description + '(' + obj.code + ')'
                })
            });
            callback(temp)
        })
    }


      /**
    * @author Vanitha
    * @description Get Ownership status
    */
     getOwnershipStatus(callback) {
      this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/owner/status/list", (result) => {
            callback(result)
        })
    }

        updatePageLimit(userId, limit,callback){
       this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/user/updatePageLimit?userId=" + userId + "&pageLimit=" + limit, result => {
            callback(result);

        })
}
       /*
     * @author Vanitha
     * @uses region list
     * @date 25-11-2019
     */

        getRegionList(callback){
        const temp = [];
        this._globalDataService.GetAjaxCall(this.BASE_URL + '/lms/user/region/list', (result) => {
        result.forEach(obj => {
        temp.push({
          id: obj.id,
          code: obj.code,
          description: obj.description,
          codeDescription: obj.code + '(' + obj.description + ')'
        })
        });
         callback(temp);
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/owners/services/owner.service.ts